<template>
  <div class="compressed-content">
    <h3 class="page-question">
      Have you been told there is ANY blockage (sometimes called “plaque”) in your heart, <br />
      neck, or leg arteries? This would have likely been from a CT scan of your heart, a CAC <br />
      score, or a CIMT of your neck arteries?<br /><i>(Check all that apply)</i>
    </h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.blockageHistory">
      <b-form-checkbox v-model="survey.arteryBlockages.blockageHistory.hadNoPlaque" @change="onNoPlaqueSelected">
        No
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.arteryBlockages.blockageHistory.hadCoronaryPlaque" @change="onCoronaryPlaqueSelected">
        Heart arteries (coronary arteries)
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.arteryBlockages.blockageHistory.hadCarotidPlaque" @change="onCarotidPlaqueSelected">
        Neck arteries (carotid arteries)
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.arteryBlockages.blockageHistory.hadLegPlaque" @change="onLegPlaqueSelected">
        Leg arteries
      </b-form-checkbox>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');
  import { anyOptionRequired } from 'utils/custom-validators';

  export default {
    mixins: [formMixin],

    validations: {
      blockageHistory: {
        anyOptionRequired: anyOptionRequired((value) => value.hadNoPlaque || value.hadCoronaryPlaque
          || value.hadCarotidPlaque || value.hadLegPlaque)
      }
    },

    computed: {
      ...mapState(["survey"]),

      blockageHistory() { return this.survey.arteryBlockages.blockageHistory; }
    },

    methods: {
      onNoPlaqueSelected(value) {
        this.setOptions(value, false, false, false);
      },

      onCoronaryPlaqueSelected(value) {
        this.setOptions(false, value, this.blockageHistory.hadCarotidPlaque, this.blockageHistory.hadLegPlaque);
      },

      onCarotidPlaqueSelected(value) {
        this.setOptions(false, this.blockageHistory.hadCoronaryPlaque, value, this.blockageHistory.hadLegPlaque);
      },

      onLegPlaqueSelected(value) {
        this.setOptions(false, this.blockageHistory.hadCoronaryPlaque, this.blockageHistory.hadCarotidPlaque, value);
      },

      setOptions(hadNoPlaque, hadCoronaryPlaque, hadCarotidPlaque, hadLegPlaque) {
        this.survey.arteryBlockages.blockageHistory.hadNoPlaque = hadNoPlaque;
        this.survey.arteryBlockages.blockageHistory.hadCoronaryPlaque = hadCoronaryPlaque;
        this.survey.arteryBlockages.blockageHistory.hadCarotidPlaque = hadCarotidPlaque;
        this.survey.arteryBlockages.blockageHistory.hadLegPlaque = hadLegPlaque;
      }
    }
  };
</script>